var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "confirm-order-container" },
    [
      _c("van-nav-bar", {
        attrs: { title: _vm.$route.meta.title },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function() {
              return [
                _c("van-icon", {
                  attrs: { name: "arrow-left", color: "#46474B", size: "20px" },
                  on: { click: _vm.back }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "confirm-order-top" },
        [
          _c("NoticeListBar", {
            staticClass: "notice-box",
            attrs: { "show-head-img": true }
          })
        ],
        1
      ),
      _c("div", { staticClass: "wrap" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.serverData.type === 1 || _vm.serverData.type === 3,
                expression: "serverData.type === 1 || serverData.type === 3"
              }
            ],
            staticClass: "steps"
          },
          [
            _vm._m(0),
            _c("span", { staticClass: "steps-item flex flex-align-center" }, [
              _vm._v(
                "2." +
                  _vm._s(_vm.serverData.type === 1 ? "极速响应" : "律师接单") +
                  " "
              ),
              _c("img", {
                attrs: {
                  src: require("@/assets/common/sysarrow2-yellow.png"),
                  alt: ""
                }
              })
            ]),
            _vm._m(1),
            _c("span", { staticClass: "steps-item flex flex-align-center" }, [
              _vm._v("4.服务评价 ")
            ])
          ]
        ),
        _c("p", { class: ["title", _vm.serverData.type === 2 && "title-t"] }, [
          _vm._v(" 购买服务"),
          _c("span", [_vm._v("下单后即可联系律师")])
        ]),
        _c("div", { staticClass: "pay-card free-c card-active" }, [
          _c("div", { staticClass: "pay-card-top" }, [
            _c("span", { staticClass: "right-text" }, [
              _vm._v(
                "极速" + _vm._s(_vm.serverData.type === 2 ? "通道" : "响应")
              )
            ]),
            _c("div", [
              _c("div", { staticClass: "flex" }, [
                _c("img", {
                  staticClass: "dicon",
                  attrs: { src: _vm.serverData.icon, alt: "" }
                }),
                _c(
                  "div",
                  { staticClass: "flex flex-column flex-space-between" },
                  [
                    _c("span", { staticClass: "titlename" }, [
                      _vm._v(_vm._s(_vm.serverData.serviceName))
                    ]),
                    _c("div", { staticClass: "flex" }, [
                      _vm.serverData.serviceNum && _vm.serverData.unitLabel
                        ? _c("div", { staticClass: "flex info" }, [
                            _c("div", { staticClass: "sub-t font12" }, [
                              _vm._v(
                                " 购买规格: " +
                                  _vm._s(
                                    _vm.serverData.serviceNum +
                                      _vm.serverData.unitLabel
                                  ) +
                                  " "
                              )
                            ]),
                            _c("div", { staticClass: "price" }, [
                              _c("p", { staticClass: "origin-price" }, [
                                _vm._v(
                                  " ¥" +
                                    _vm._s(
                                      _vm.amountFilter(
                                        _vm.serverData.originalPrice
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c("p", { staticClass: "servicePrice-price" }, [
                                _vm._v(
                                  " ¥" +
                                    _vm._s(
                                      _vm.amountFilter(
                                        _vm.serverData.servicePrice
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ])
                        : _c("div", { staticClass: "sub-price" }, [
                            _vm._v(
                              " ¥" +
                                _vm._s(
                                  _vm.amountFilter(_vm.serverData.servicePrice)
                                ) +
                                " "
                            )
                          ])
                    ])
                  ]
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "infobox" }, [
            _c(
              "div",
              { staticClass: "rate" },
              [
                _c("van-rate", {
                  staticClass: "rate-item-star",
                  attrs: {
                    readonly: "",
                    value: 5,
                    count: 5,
                    size: "0.4rem",
                    gutter: "0.3rem",
                    color: "#FFA701",
                    "void-icon": _vm.icon,
                    icon: _vm.iconSelected,
                    "void-color": "#DCDFE4"
                  }
                }),
                _vm._v(" 99%好评 ")
              ],
              1
            ),
            _c("div", { staticClass: "count" }, [
              _vm._v(" " + _vm._s(_vm.serverData.buyersNums)),
              _c("span", [_vm._v("人已付款")])
            ])
          ])
        ]),
        _vm.serverData.type === 1
          ? _c("div", { staticClass: "onevone font12" }, [
              _vm._v(" 您正在购买"),
              _c("img", {
                staticClass: "img",
                attrs: { alt: "", src: _vm.lawyerData.imgUrl, srcset: "" }
              }),
              _vm._v(
                _vm._s(_vm.lawyerData.realName) +
                  "律师的服务,支付成功后立即进入一对一咨询 "
              )
            ])
          : _vm.serverData.type === 3
          ? _c("div", { staticClass: "common-info" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.commonLawyerList.length,
                      expression: "commonLawyerList.length"
                    }
                  ],
                  staticClass: "lawyer"
                },
                [
                  _vm._m(2),
                  _c(
                    "div",
                    { staticClass: "lawyer-list flex" },
                    _vm._l(_vm.commonLawyerList.slice(0, 10), function(
                      item,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: index + "commonLawyerList",
                          staticClass: "item"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                item.imgUrl ||
                                require("@/assets/imgs/plusPage/headimg.png"),
                              alt: "",
                              srcset: ""
                            }
                          }),
                          _c("p", { staticClass: "name font10" }, [
                            _vm._v(" " + _vm._s(item.realName || "律师") + " ")
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          : _c("div", { staticClass: "other font12" }, [
              _vm._v(
                " 你正在购买平台加急服务，支付成功可享受金牌律师优先为你解决问题 "
              )
            ])
      ]),
      _c("div", { staticClass: "handle-bottom" }, [
        _c(
          "div",
          { staticClass: "payway-box" },
          _vm._l(_vm.payList, function(item, index) {
            return _c(
              "div",
              {
                key: index + "payList",
                staticClass: "payway flex flex-space-between flex-align-center",
                on: {
                  click: function($event) {
                    return _vm.selectPayWay(item)
                  }
                }
              },
              [
                _c("div", { staticClass: "flex flex-align-center" }, [
                  _c("img", {
                    staticClass: "wxpayicon",
                    attrs: { src: item.icon, alt: "" }
                  }),
                  _c("span", [_vm._v(_vm._s(item.title))])
                ]),
                _c("img", {
                  staticClass: "payselect",
                  attrs: {
                    src: require("@/assets/common/" +
                      (_vm.payWay !== Number(item.code)
                        ? "zx_nocheck"
                        : "payselect") +
                      ".png")
                  }
                })
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "bt", on: { click: _vm.toCreateOrder } }, [
          _vm._v(
            " 立即支付 ¥" +
              _vm._s(_vm.amountFilter(_vm.serverData.servicePrice)) +
              " "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "steps-item flex flex-align-center" }, [
      _c("span", [_vm._v("1.支付订单 ")]),
      _c("img", {
        attrs: { src: require("@/assets/common/sysarrow2-yellow.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "steps-item flex flex-align-center" }, [
      _vm._v("3.极速服务 "),
      _c("img", {
        attrs: { src: require("@/assets/common/sysarrow2-yellow.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "sb-title font13" }, [
      _c("span", [_vm._v("以下律师将会为您服务：")]),
      _c("span", { staticClass: "desc" }, [_vm._v("全国累计1万余名律师入驻")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }